// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Attachment } from './attachment';
import { Customer } from './customer';
import { CustomerTaxCode } from './customer-tax-code';
import { InvoiceLine } from './invoice-line';
import { InvoicePaymentMethod } from './invoice-payment-method';
import { InvoiceStatus } from './invoice-status';
import { InvoiceType } from './invoice-type';
import { PaymentLine } from './payment-line';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Invoice extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Types = {
        Invoice: 1,
        Credit: 2,
    };

    get statusName() {
        return this.status ? this.status.name : '';
    }

    get displayBillAddress() {
        let address = [];
        address.push(this.billToAddress1);
        address.push(this.billToAddress2);
        address.push(this.billToCity);
        address.push(this.billToState);
        address.push(this.billToZip);
        return address.join('\r\n');
    }

    get unpaidBalance() {
        return this.total - this.paymentLinesTotal;
    }

    get isMail() {
        if (!this.customer) return false;
        return this.customer.preferredCommunication === 'Mail' || this.customer.preferredCommunication === 'Both';
    }

    get isEmail() {
        if (!this.customer) return false;
        return this.customer.preferredCommunication === 'Email' || this.customer.preferredCommunication === 'Both';
    }
    get paymentLinesTotal() {
        return this.paymentLines.filter((x) => !x.deleted).reduce((a, b) => a + b.amount, 0);
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  balance!: number;
  billToAddress1?: string;
  billToAddress2?: string;
  billToCity?: string;
  billToContactName?: string;
  billToCountry?: string;
  billToEmail?: string;
  billToPhone?: string;
  billToState?: string;
  billToZip?: string;
  created!: Date;
  createdBy?: string;
  customerId?: number;
  customerTaxCodeId?: number;
  deleted?: Date;
  deletedBy?: string;
  dueDate!: Date;
  emailed?: Date;
  invoiceCode?: string;
  invoiceDate!: Date;
  invoiceNumber!: number;
  invoiceTypeId?: number;
  notes?: string;
  pONumber?: string;
  paid?: Date;
  paymentMethodId!: number;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  readyToExport?: Date;
  referencedInvoiceId?: number;
  shipTo?: string;
  statusId!: number;
  subTotal!: number;
  tax!: number;
  terms?: string;
  total!: number;
  attachments!: Attachment[];
  customer!: Customer;
  customerTaxCode!: CustomerTaxCode;
  invoiceLines!: InvoiceLine[];
  invoiceType!: InvoiceType;
  paymentLines!: PaymentLine[];
  paymentMethod!: InvoicePaymentMethod;
  referencedInvoice!: Invoice;
  status!: InvoiceStatus;
}

